// Import Foundation Core
import { Foundation } from 'foundation-sites/js/foundation.core';

// Import Foundation Plugins
import { Touch } from 'foundation-sites/js/foundation.util.touch';
import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
import { Abide } from 'foundation-sites/js/foundation.abide';
import { Drilldown } from 'foundation-sites/js/foundation.drilldown';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu';
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';
import { ResponsiveMenu } from 'foundation-sites/js/foundation.responsiveMenu';
import { Reveal } from 'foundation-sites/js/foundation.reveal';
import { Slider } from 'foundation-sites/js/foundation.slider';
import { Tooltip } from 'foundation-sites/js/foundation.tooltip';
import { Accordion } from 'foundation-sites/js/foundation.accordion';
import { AccordionMenu } from 'foundation-sites/js/foundation.accordionMenu';

// Import Third Party
import 'owl.carousel/dist/owl.carousel';
// Import foundation extensions
import carousel from '../extensions/owl.carousel';

// Set some defaults
Dropdown.defaults.hoverDelay = 100;

Foundation.addToJquery($);
Touch.init($);
Triggers.init($, Foundation);
Foundation.plugin(Abide, 'Abide');
Foundation.plugin(Drilldown, 'Drilldown');
Foundation.plugin(Dropdown, 'Dropdown');
Foundation.plugin(DropdownMenu, 'DropdownMenu');
Foundation.plugin(OffCanvas, 'OffCanvas');
Foundation.plugin(ResponsiveMenu, 'ResponsiveMenu');
Foundation.plugin(Reveal, 'Reveal');
Foundation.plugin(Slider, 'Slider');
Foundation.plugin(Tooltip, 'Tooltip');
Foundation.plugin(Accordion, 'Accordion');
Foundation.plugin(AccordionMenu, 'AccordionMenu');

// We add our own extensions to $.fn.foundation
// Extensions are functions, whose will be called, when $.fn.foundation() is called on an element
// the $element, on which foundation() is called, will be given as fist parameter to the extension.
// The extensions will be called in registration order!
const extensions = [];
const origFoundation = $.fn.foundation;
$.fn.foundation = function (method, ...args) {
  // Proxy pass to foundation
  origFoundation.bind(this)(method, ...args);

  // Need to initialize extensions only when method is undefined (like foundation does it)
  if (typeof method === 'undefined') {
    extensions.forEach((fn, index) => {
      fn(this, index);
    });
  }

  return this;
};

Foundation.registerExtension = (fn) => {
  extensions.push(fn);
};

extensions.push(carousel);

// Initialize foundation on document ready
$(document).ready(() => {
  $(document).foundation();
});

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
Foundation.util.debounce = function _(func, wait, immediate) {
  let timeout;
  return function __(...args) {
    const context = this;
    const later = function ___() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
